<form class="amount-field" [formGroup]="gvcAmountFormGroup">
    <div class="form-control-wrapper pt-3">
        <mat-form-field hideRequiredMarker>
            <mat-label>
                {{ depositInfo?.amountInfo?.nativeCurrency | vnCurrencySymbol }}
            </mat-label>
            <input
                id="userAmount"
                name="userAmount"
                formControlName="userAmount"
                matInput
                required
                #userAmount
                inputmode="none"
                [(ngModel)]="depositInfo.amountInfo.nativeAmountString"
                step="0.01"
                class="form-control"
                [readonly]="isMobile"
                [ngClass]="{ 'pe-none': isMobile }"
                (keypress)="keyPressNumbersDecimal($event)"
                (input)="onChangeAmt()"
                ondrop="return false;"
                (focus)="show()"
                autocomplete="off"
                (focusout)="hide()"
                validNumber />
            @if (showAmountError && (gvcAmountFormGroup?.controls?.['userAmount']?.dirty || gvcAmountFormGroup?.controls?.['userAmount']?.touched)) {
                <mat-error>
                    @if (gvcAmountFormGroup?.controls?.['userAmount']?.errors?.['required']) {
                        <span>{{ 'PARTY.CASHIER.web.deposit.amount.required' | translate }}</span>
                    }
                    @if (gvcAmountFormGroup?.controls?.['userAmount']?.errors?.['pattern']) {
                        <span>{{ 'PARTY.CASHIER.web.deposit.amount.invalid' | translate }}</span>
                    }
                    @if (gvcAmountFormGroup?.controls?.['userAmount']?.hasError('providerBalance')) {
                        <span>{{ 'PARTY.CASHIER.web.deposit.prepaidcard.accountbalance.error' | translate }}</span>
                    }
                    @if (
                        !gvcAmountFormGroup?.controls?.['userAmount']?.errors?.['pattern'] &&
                        !gvcAmountFormGroup?.controls?.['userAmount']?.errors?.['providerBalance']
                    ) {
                        <ng-container>
                            @if (gvcAmountFormGroup?.controls?.['userAmount']?.hasError('min')) {
                                <span>
                                    {{ 'PARTY.CASHIER.web.common.min.label' | translate }} :
                                    {{ selectedOption?.paymentMethodInfo?.minDepositLimit?.value | vnCurrency }}
                                </span>
                            }
                            @if (
                                gvcAmountFormGroup?.controls?.['userAmount']?.hasError('max') &&
                                !gvcAmountFormGroup?.controls?.['userAmount']?.hasError('selfSetLimit')
                            ) {
                                <span>
                                    {{ 'PARTY.CASHIER.web.common.max.label' | translate }} :
                                    {{ selectedOption?.paymentMethodInfo?.maxDepositLimit?.value | vnCurrency }}
                                </span>
                            }
                        </ng-container>
                    }
                </mat-error>
            }
        </mat-form-field>
    </div>
</form>
